/* CarLotSupplies Blog Hub — search, filter, sort, hero rotator */
(function () {
  'use strict';

  var hub = document.querySelector('.blog-hub');
  if (!hub) return;

  // Hero rotator (cycles every 6s)
  var heroImgs = hub.querySelectorAll('#blog-hero-rotator .blog-hub__hero-img');
  if (heroImgs.length > 1) {
    var idx = 0;
    setInterval(function () {
      heroImgs[idx].classList.remove('is-active');
      idx = (idx + 1) % heroImgs.length;
      heroImgs[idx].classList.add('is-active');
    }, 6000);
  }

  var grid = document.getElementById('blog-hub-grid');
  if (!grid) return;
  var searchInput = document.getElementById('blog-hub-search');
  var clearBtn = document.getElementById('blog-hub-search-clear');
  var sortSelect = document.getElementById('blog-hub-sort');
  var countEl = document.getElementById('blog-hub-count');
  var emptyEl = document.getElementById('blog-hub-empty');
  var filterChips = hub.querySelectorAll('#blog-hub-filters .chip');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.blog-card'));

  var activeFilter = 'all';
  var query = '';

  function pluralize(n, singular, plural) {
    return n === 1 ? singular : plural;
  }

  function applyFilters() {
    var q = query.toLowerCase().trim();
    var visible = 0;
    cards.forEach(function (card) {
      var title = (card.dataset.title || '').toLowerCase();
      var tags = (card.dataset.tags || '').toLowerCase();
      var content = (card.dataset.content || '').toLowerCase();
      var handle = (card.dataset.handle || '').toLowerCase();

      var matchesSearch = !q || title.indexOf(q) >= 0 || tags.indexOf(q) >= 0 ||
                         content.indexOf(q) >= 0 || handle.indexOf(q) >= 0;
      var matchesFilter = activeFilter === 'all' ||
                          tags.indexOf(activeFilter) >= 0 ||
                          title.indexOf(activeFilter) >= 0;

      if (matchesSearch && matchesFilter) {
        card.classList.remove('is-hidden');
        visible++;
      } else {
        card.classList.add('is-hidden');
      }
    });

    if (countEl) {
      countEl.textContent = visible + ' ' + pluralize(visible, 'article', 'articles');
    }
    if (emptyEl) {
      emptyEl.hidden = visible !== 0;
    }
  }

  function applySort() {
    if (!sortSelect) return;
    var mode = sortSelect.value;
    var sorted = cards.slice().sort(function (a, b) {
      switch (mode) {
        case 'newest':
          return Number(b.dataset.date) - Number(a.dataset.date);
        case 'oldest':
          return Number(a.dataset.date) - Number(b.dataset.date);
        case 'title-asc':
          return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        case 'reading-time':
          return Number(a.dataset.reading || 99) - Number(b.dataset.reading || 99);
        default:
          return 0;
      }
    });
    sorted.forEach(function (c) { grid.appendChild(c); });
  }

  function debounce(fn, delay) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  if (searchInput) {
    var doSearch = debounce(function () {
      query = searchInput.value;
      if (clearBtn) clearBtn.hidden = !query.trim();
      applyFilters();
    }, 80);
    searchInput.addEventListener('input', doSearch);
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      searchInput.value = '';
      query = '';
      clearBtn.hidden = true;
      searchInput.focus();
      applyFilters();
    });
  }
  if (sortSelect) {
    sortSelect.addEventListener('change', applySort);
  }
  filterChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      filterChips.forEach(function (c) { c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      activeFilter = chip.dataset.filter || 'all';
      applyFilters();
    });
  });

  window.blogHubReset = function () {
    if (searchInput) { searchInput.value = ''; }
    query = '';
    if (clearBtn) clearBtn.hidden = true;
    activeFilter = 'all';
    filterChips.forEach(function (c) {
      c.classList.toggle('is-active', c.dataset.filter === 'all');
    });
    applyFilters();
  };

  // URL hash/query support: ?search=foo&tag=bar
  try {
    var params = new URLSearchParams(window.location.search);
    var qParam = params.get('search') || params.get('q');
    var tagParam = params.get('tag');
    if (qParam && searchInput) {
      searchInput.value = qParam;
      query = qParam;
      if (clearBtn) clearBtn.hidden = false;
    }
    if (tagParam) {
      filterChips.forEach(function (c) {
        if ((c.dataset.filter || '').toLowerCase() === tagParam.toLowerCase()) {
          filterChips.forEach(function (cc) { cc.classList.remove('is-active'); });
          c.classList.add('is-active');
          activeFilter = tagParam.toLowerCase();
        }
      });
    }
    if (qParam || tagParam) applyFilters();
  } catch (_) { /* ignore */ }
})();
